import { Classes, Collapse, Icon } from "@focus/focusUI";
import React from "react";
import "./ChangesList.scss";
export const ChangesList = ({ changes }) => {
    const [isListOpen, setIsListOpen] = React.useState(true);
    const changesList = Object.keys(changes).map((key, i) => (React.createElement(ChangeListItem, { key: key + "_" + i, changeId: key })));
    return (React.createElement("div", { className: "change-panel", role: "changelist" },
        React.createElement("div", { className: "change-title", onClick: () => setIsListOpen(!isListOpen) },
            React.createElement("h3", { className: `change-title-text panel-title ${Classes.HEADING}` },
                React.createElement(Icon, { className: "change-icon", icon: isListOpen ? "chevron-up" : "chevron-down" }),
                "Changes")),
        React.createElement(Collapse, { isOpen: isListOpen, keepChildrenMounted: true },
            React.createElement("ul", { className: "list-group" }, changesList))));
};
export const ChangeListItem = ({ className, changeId, }) => {
    const text = changeId;
    const classType = className
        ? className + " text-primary"
        : "list-group-item text-primary";
    return React.createElement("li", { className: classType }, `${text}`);
};
//# sourceMappingURL=ChangesList.js.map